import { BASE_URL } from './apiClient';

// Authentication related endpoints
export const AUTH_URLS = {
  login: `${BASE_URL}/api/login`,
  register: `${BASE_URL}/api/register`,
  logout: `${BASE_URL}/api/logout`, // TODO: no backend route — logout is client-side only (JWT)
  me: `${BASE_URL}/api/me`,
};

// User management endpoints
export const USER_URLS = {
  getAllUsers: `${BASE_URL}/api/users`,
  getMe: `${BASE_URL}/api/me`,
  updateUser: (userId) => `${BASE_URL}/api/users/${userId}`,
  importUsers: `${BASE_URL}/api/users/import`,
};

// Catalog orders endpoints
export const CATALOG_URLS = {
  createOrder: `${BASE_URL}/api/catalog-orders/catalog-orders/`,
  getAllOrders: `${BASE_URL}/api/catalog-orders/catalog-orders/`,
  updateOrder: (orderId) => `${BASE_URL}/api/catalog-orders/catalog-orders/${orderId}`,
};

// Tasking orders endpoints
export const TASKING_URLS = {
  createOrder: `${BASE_URL}/api/catalog-orders/tasking-orders/`,
  getAllOrders: `${BASE_URL}/api/catalog-orders/tasking-orders/`,
  updateOrder: (orderId) => `${BASE_URL}/api/catalog-orders/tasking-orders/${orderId}`,
};

// Satellite endpoints
export const SATELLITE_URLS = {
  getTrack: `${BASE_URL}/api/satellites/track`,
};

// Preview and data processing endpoints
export const IMAGE_URLS = {
  getPreview: (imageId) => `${BASE_URL}/api/preview/${imageId}`,
  getBestScenes: `${BASE_URL}/api/best-scenes`, // TODO: no backend route yet
  downloadPreview: (imageId) => `${BASE_URL}/api/download-preview/${imageId}`,
};

// Search and catalog endpoints
export const SEARCH_URLS = {
  catalog: `${BASE_URL}/api/search`,
  checkFeasibility: `${BASE_URL}/api/check-feasibility`,
  downloadFeasibility: `${BASE_URL}/api/export-feasibility`,
  downloadFeasibilityXLSX: `${BASE_URL}/api/export-feasibility-xlsx`,
  downloadFeasibilityCSVCombined: `${BASE_URL}/api/export-feasibility-csv-combined`,
  getProducts: `${BASE_URL}/api/products`,
};

// AOI endpoints
export const AOI_URLS = {
  getSavedAOIs: `${BASE_URL}/api/saved-aois`,
  saveAOI: `${BASE_URL}/api/saved-aois`,
  deleteAOI: (aoiId) => `${BASE_URL}/api/saved-aois/${aoiId}`,
};

// Utility function to build URLs with query parameters
export const buildUrl = (baseUrl, params = {}) => {
  const query = Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
  return query ? `${baseUrl}?${query}` : baseUrl;
};
